const POOL_INFO = 'index/POOL_INFO' as const;
const SET_POOL_INFO = 'index/SET_POOL_INFO' as const;
export const getPoolInfo = () => ({
  type: POOL_INFO,
});

export const setPoolInfo = (state: PoolDataRes) => ({
  type: SET_POOL_INFO,
  payload: state,
});

type PoolAction = ReturnType<typeof getPoolInfo> | ReturnType<typeof setPoolInfo>;
export type PoolDataRes = string[];
// 이 리덕스 모듈에서 관리 할 상태의 타입을 선언합니다

// 초기상태를 선언합니다.
const initialState: PoolDataRes = [];

function pool(state: PoolDataRes = initialState, action: PoolAction): any {
  switch (action.type) {
    case POOL_INFO:
      return [...state];
    case SET_POOL_INFO:
      return [...action.payload];
    default:
      return state;
  }
}

export default pool;
